<template>
  <div
    class="multiselect-custom-field d-flex justify-content-between anchor"
    :class="classList"
  >
    <multiselect
      :max-height="200"
      :searchable="false"
      :allowEmpty="false"
      :placeholder="'hh'"
      :selectLabel="''"
      :selectedLabel="''"
      :deselectLabel="''"
      :disabled="disabled"
      :options="hoursOptions"
      :value="hours"
      @input="emitHours"
    >
      <div
        class="caret"
        slot="caret"
        slot-scope="{ toggle }"
        @mousedown.prevent.stop="toggle"
      >
        <i
          class="Ctrl Ctrl--16"
          aria-hidden="true"
        >
          <svg
            focusable="false"
            aria-hidden="true"
            aria-label="Edit"
          >
            <use xlink:href="#dropdown-icon"></use>
          </svg>
        </i>
      </div>
      <template
        slot="singleLabel"
        slot-scope="props"
      >
        {{`${props.option} h`}}
      </template>

    </multiselect>
    <multiselect
      :max-height="200"
      :allowEmpty="false"
      :searchable="false"
      :placeholder="'mm'"
      :selectLabel="''"
      :deselectLabel="''"
      :selectedLabel="''"
      :disabled="disabled"
      :options="minutesOptions"
      :value="minutes"
      @input="emitMinutes"
    >

      <div
        class="caret"
        slot="caret"
        slot-scope="{ toggle }"
        @mousedown.prevent.stop="toggle"
      >
        <i
          class="Ctrl Ctrl--16"
          aria-hidden="true"
        >
          <svg
            focusable="false"
            aria-hidden="true"
            aria-label="Edit"
          >
            <use xlink:href="#dropdown-icon"></use>
          </svg>
        </i>
      </div>
      <template
        slot="singleLabel"
        slot-scope="props"
      >
        {{`${props.option} min`}}
      </template>

    </multiselect>
    <img
      :src="require('@/assets/img/icons/close.svg')"
      alt="close"
      class="p-2"
      @click="clearTime"
    >

    <img
      :src="require('@/assets/img/icons/icon-watch.svg')"
      alt="watch"
      class="p-2"
    >

  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { hoursADay, minutesAnHour } from '@/utils/constants'
export default {
  name: 'TimeSelectorInput',
  components: { Multiselect },
  props: {
    id: {
      type: [String, Number]
    },
    hours: {
      type: [Number, String],
      required: true
    },
    minutes: {
      type: [Number, String],
      required: true
    },

    disabled: {
      type: Boolean
    },
    classList: {
      type: String
    }
  },
  computed: {
    hoursOptions () {
      return hoursADay
    },
    minutesOptions () {
      return minutesAnHour
    }
  },
  methods: {
    emitHours (event) {
      this.$emit('changeHours', event)
    },
    emitMinutes (event) {
      this.$emit('changeMinutes', event)
    },
    clearTime () {
      this.$emit('resetTime')
      // this.$emit('update:hours', '00')
      // this.$emit('update:minutes', '00')
    }

  }

}
</script>

  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.multiselect-custom-field {
  background-color: var(--fill-text-area);
}
</style>
